var Theme = {
  bind: function() {

    /* Product detail slideshow */

    $(document).on('click', '.product .image', function(event) {
      $('[data-behavior="next-image"]').trigger('click');
    });

    var swapImages = function(fromImage, toImage) {
      $(fromImage).fadeOut(400, function() {
        $(this).removeClass('selected');

        $(toImage).fadeIn(400, function() {
          $(this).addClass('selected');
        });
      });
    }

    $(document).on('click', '[data-behavior="next-image"]', function(event) {
      event.preventDefault();

      var currentImage = $('.product .image.selected');
      var nextImage = $(currentImage).next();

      if ($(nextImage).length === 0) {
        nextImage = $('.product .images').children().first();
      }

      swapImages(currentImage, nextImage);
    });

    $(document).on('click', '[data-behavior="previous-image"]', function(event) {
      event.preventDefault();

      var currentImage = $('.product .image.selected');
      var previousImage = $(currentImage).prev();

      if ($(previousImage).length === 0) {
        previousImage = $('.product .images').children().last();
      }

      swapImages(currentImage, previousImage)
    });


    /* Cart */

    $(document).on('click', '[data-behavior="remove-cart-item"]', function(event) {
      event.preventDefault();
      var element = this;

      $.ajax({
        type: 'POST',
        url: $(element).attr('href'),
        dataType: 'json',
        success: function(data, textStatus, jqXHR) {
          if (data.item_count > 0) {
            $(element).closest('.cart-item').fadeOut(400, function () {
              $(this).remove();
            });
            
            var itemOrItems = (data.item_count == 1) ? "item" : "items";
            var itemCount = data.item_count + " " + itemOrItems;
            $(".item-count").html(itemCount);
            console.log(itemCount);
          } else {
            
            $("#outer header .item-count").fadeOut(400, function() {
              $("#outer header .item-count").replaceWith("");
            });

            $(element).closest('form').fadeOut(400, function() {
              $(element).closest('form').replaceWith('<div class="cart empty"><p>You have nothing in your cart.</p></div>');
            });
          }
        }
      });
    });

    $(document).on('click', '[data-behavior="update-cart"]', function(event) {
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: $(this).attr('href'),
        data: $(this).closest('form').serialize(),
        dataType: 'json',
        success: function(data, textStatus, jqXHR) {
          window.location = '/cart';
        }
      });
    });
  }
};
